export interface InternationalTopUpPhoneContext {
    phoneNumber: string;
    countryCode: string;
    dialCode: string;
}
